import React from "react";
import ReactDOM from "react-dom/client";
import "index.css";
import "utils";
import App from "App";
import { IS_PROD } from "config";

if (IS_PROD) {
  console.log = () => {};
  console.debug = () => {};
  console.warn = () => {};
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
